import { TileasTileLayer } from 'ol/layer';
import { filter } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { MENU_ITEMS_BY_ROLE, ENTITIES_CHILDREN_DEFAULT, MAIN_MENUS_BY_DEFAULT } from './pages-menu';
import { UserSessionService } from '../UserSession/user-session.service';
import { NbMenuItem } from '@nebular/theme';
import { ImagesService } from '../apiclient';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Renderiza el contenedor de páginas de la app
 */
@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `<div id="maincont" [style.background-color]="'#edf1f7'" [style.background-image]="'url(' + companybackground  + ')'">
    <ngx-one-column-layout >
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
    </div>
  `,
})
export class PagesComponent implements OnInit, OnDestroy{

  menu = [];
  companybackground: any;
  childrenUpd = JSON.parse(JSON.stringify(ENTITIES_CHILDREN_DEFAULT));
  public constructor(
    private userSessionService: UserSessionService,
    private imagesService: ImagesService,
    private sanitizer: DomSanitizer,

  ) {


  }

  /**
   * @ignore
   */
  ngOnDestroy(): void {

  }

  /**
   * @ignore
   */
  ngOnInit(): void {
    this.getMenuByUser(this.userSessionService.user);
    console.log("Se inicializa el pages.component")

    //Cargamos el logo de la compañía
    this.imagesService.imageImagepathGet(this.userSessionService.user.company.dashboardBackgroundImage,
      this.userSessionService.accessToken).subscribe((data) => {
          console.log("Obtenemos background");
          console.log(data);
          if(null != data && typeof data != 'undefined'){
            this.convertBlobToBase64(data).then((result) => {
              this.companybackground = result;
              console.log("BACKGROUND")
              console.log(result);
            })

          }

      });

      /*
      this.userSessionService.onSessionCreated().subscribe(session => {
        console.log("PAGES_COMPONENT: Actualiamos menu");
        this.getMenuByUser(this.userSessionService.user);
      })
      */
  }


  /**
   * Obtiene el menú a renderizar según el usuario
   * @param user
   */
  private  getMenuByUser(user: any){

    this.menu = []
    user.acl_roles.forEach((role) => {
      this.menu = this.menu.concat(JSON.parse(JSON.stringify(MENU_ITEMS_BY_ROLE[role])));
        console.log(this.menu)
        if(role == 'manager'){
          console.log("GENERA MENU MANAGER")
          this.generarMenuRaiz();
          this.generarMenuMapas();
          this.generarMenuInformes();
          this.generarMenuClima();

          this.generarMenuCustomEntities();
        }
        console.log(this.menu)
    });

}

/**
 * GEnera el menú de mapas
 */
private generarMenuMapas(){
    this.userSessionService.getFramelinks().subscribe((links) => {


      console.log("Tenemos los links de los mapas");
      //console.log(links.Mapas);
      let mapas = [];

      let grouped_links = {};

      for (let key in links.Mapas){
        if(key == 'nocategory'){
            console.log(links.Mapas[key])
            links.Mapas[key].forEach((cardlink) => {
              let menu = {title : cardlink.show_name, link : '/pages/viewframelink/'
              +encodeURIComponent(cardlink.link)};
              if(cardlink.icon != undefined && cardlink.icon != null){
                (menu as any).icon = cardlink.icon
              }
              mapas.push(menu);
            });
        }else{
          console.log(links.Mapas[key])
          let hijos = [];
          links.Mapas[key].forEach((cardlink) => {
            let menu = {title : cardlink.show_name,expanded:true, link:'/pages/viewframelink/'+
            encodeURIComponent(cardlink.link)};
            if(cardlink.icon != undefined && cardlink.icon != null){
              (menu as any).icon = cardlink.icon
            }
            hijos.push(menu);
          });

          let categoria = {title : key, icon : 'more-vertical-outline',expanded:false, children :hijos};
          mapas.push(categoria);

        }
      }

     // console.log(mapas);
      this.menu.map( (item,index,elementos) => {
          if (item.menuId == 'mapas'){
            item.children = item.children.concat(mapas);
            /*
            item.children.map((subitem,index,elementos) => {
                if (subitem.title == "Card-Links"){
                  subitem.children = mapas;
                }

                return subitem;
            })
            */
          }

          return item;
      });
    })
}

/**
 * Genera el menú de informes
 */
private generarMenuInformes(){
  this.userSessionService.getFramelinks().subscribe((links) => {


    console.log("Tenemos los links de los informes");
   // console.log(links.Informes);
    let mapas = [];

    let grouped_links = {};

    for (let key in links.Informes){
      if(key == 'nocategory'){
          console.log(links.Informes[key])
          links.Informes[key].forEach((cardlink) => {
            let menu = {title : cardlink.show_name, link : '/pages/viewframelink/'
            +encodeURIComponent(cardlink.link)};
            if(cardlink.icon != undefined && cardlink.icon != null){
              (menu as any).icon = cardlink.icon
            }
            mapas.push(menu);
          });
      }else{
        console.log(links.Informes[key])
        let hijos = [];
        links.Informes[key].forEach((cardlink) => {
          let menu = {title : cardlink.show_name,expanded:true, link:'/pages/viewframelink/'+
          encodeURIComponent(cardlink.link)};
          if(cardlink.icon != undefined && cardlink.icon != null){
            (menu as any).icon = cardlink.icon
          }
          hijos.push(menu);
        });

        let categoria = {title : key, icon : 'more-vertical-outline',expanded:false, children :hijos};
        mapas.push(categoria);

      }
    }

   // console.log(mapas);
    this.menu.map( (item,index,elementos) => {
        if (item.menuId == 'informes'){
          item.children = item.children.concat(mapas);
          /*
          item.children.map((subitem,index,elementos) => {
              if (subitem.title == "Card-Links"){
                subitem.children = mapas;
              }

              return subitem;
          })
          */
        }

        return item;
    });
  })
}

/**
 * Genera el menú de clima
 */
private generarMenuClima(){
  this.userSessionService.getFramelinks().subscribe((links) => {
    console.log("Tenemos los links de Clima");
  //  console.log(links.Clima);
    let clima = [];

    let grouped_links = {};

    for (let key in links.Clima){
      if(key == 'nocategory'){
       //   console.log(links.Clima[key])
          links.Clima[key].forEach((cardlink) => {
            let menu = {title : cardlink.show_name, icon : 'arrow-ios-forward-outline', link : '/pages/viewframelink/'
            +encodeURIComponent(cardlink.link)};
            if(cardlink.icon != undefined && cardlink.icon != null){
              (menu as any).icon = cardlink.icon
            }
            clima.push(menu);
          });
      }else{
      //  console.log(links.Clima[key])
        let hijos = [];
        links.Clima[key].forEach((cardlink) => {
          let menu = {title : cardlink.show_name, icon : 'arrow-ios-forward-outline',expanded:true, link:'/pages/viewframelink/'+
          encodeURIComponent(cardlink.link)};
          if(cardlink.icon != undefined && cardlink.icon != null){
            (menu as any).icon = cardlink.icon
          }
          hijos.push(menu);
        });

        let categoria = {title : key, icon : 'more-vertical-outline',expanded:true, children :hijos};
        clima.push(categoria);

      }
    }

   // console.log(clima);
    this.menu.map( (item,index,elementos) => {
        if (item.menuId == 'clima'){
          item.children = item.children.concat(clima);
        }

        return item;
    });
  })
}

/**
 * Sustituir link de cada hijo del menú entidades
 */
private consolidateDefaultEntitiesMenu(){
  for(let child of this.childrenUpd){
    let idEnt = this.userSessionService.legacyEntities.find(e => e.tipo === child.tipo);
    if (idEnt != undefined){
      child.link = '/pages/customentity/'+ idEnt["value"]
      child.title = idEnt.id;
    }
  }
}

/**
 * Genera el menu de entidades personalizadas
 */
private generarMenuCustomEntities(){
  this.userSessionService.getCachedCustomEntitiesFullList(-1).subscribe((entities) => {
    console.log("Tenemos las Custom Lists");


    this.consolidateDefaultEntitiesMenu();

    let lista = [];



    this.menu.map( (item,index,elementos) => {

      if (item.menuId == 'entidades'){
        item.children = JSON.parse(JSON.stringify(this.childrenUpd));

        for (let key in entities){
            let menu = {title : entities[key].name, icon:{icon : 'folder-open',pack:'font-awesome'}, link : '/pages/customentity/'
            +entities[key].id};
            if (!this.userSessionService.legacyEntities.find(e => e.value === entities[key].id) ){
              item.children.push(menu);
            }
        }

      }
    })
  })

}

/**
 * Genera el menu raiz
 */
private async generarMenuRaiz(){
    if(this.userSessionService.user.company.dashboardMenu == null){
      this.userSessionService.user.company.dashboardMenu = '[]';
    }


    var menusConfig = JSON.parse(JSON.stringify(MAIN_MENUS_BY_DEFAULT)).map(m => {

      return Object.assign(m,JSON.parse(this.userSessionService.user.company.dashboardMenu).find(me => me.menu == m.menu))
    });

    var menuinforme = menusConfig.find(me => me.menu == this.menu[0].menuId)

    for(let elemento of this.menu){
      var menuConfig = menusConfig.find(me => me.menu == elemento.menuId)
      elemento.title = menuConfig.title;
        elemento.icon = menuConfig.icon;
        if(elemento.menuId == 'mapas'){
          var menuConfVisor = menusConfig.find(me => me.menu == 'visor')
              elemento.children[0].title = menuConfVisor.title;
              elemento.children[0].icon = menuConfVisor.icon;
        }
    }

    //El submenu de visor


    //Ahora obteners los Framelinks de tipo Menú
     this.userSessionService.getFramelinks().subscribe((links) => {
      console.log("Tenemos los links de Menú raiz");
    //  console.log(links.Clima);
      let raiz = [];

      let grouped_links = {};

      for (let key in links.Menú){
        if(key == 'nocategory'){
         //   console.log(links.Clima[key])
            links.Menú[key].forEach((cardlink) => {
              let menu = {title : cardlink.show_name, icon : 'arrow-ios-forward-outline', link : '/pages/viewframelink/'
              +encodeURIComponent(cardlink.link)};
              if(cardlink.icon != undefined && cardlink.icon != null){
                (menu as any).icon = cardlink.icon
              }
              raiz.push(menu);
            });
        }else{
        //  console.log(links.Clima[key])
          let hijos = [];
          links.Menú[key].forEach((cardlink) => {
            let menu = {title : cardlink.show_name, icon : 'arrow-ios-forward-outline',expanded:false, link:'/pages/viewframelink/'+
            encodeURIComponent(cardlink.link)};
            if(cardlink.icon != undefined && cardlink.icon != null){
              (menu as any).icon = cardlink.icon
            }
            hijos.push(menu);
          });

          let categoria = {title : key, icon : 'more-vertical-outline',expanded:false, children :hijos};
          raiz.push(categoria);

        }
      }

      //Añadimos los nuevos elementos
      if (raiz.length > 0){
        raiz.forEach((item,index,array) => {
          this.menu.splice(3+index,0,item)
        })

      }
      console.log(this.menu);
    })
}

/**
 * @iognore
 * @param blob
 * @returns
 */
convertBlobToBase64(blob): Promise<any>{
 return new Promise((resolve, reject) => {
  const reader = new FileReader;
  reader.onerror = reject;
  reader.onload = () => {
      resolve(reader.result);
  };
  reader.readAsDataURL(blob);
});
}

}


